import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Button = ({ classes, disabled, children, outline, onClick, type }) => {
  const defaultStyle =
    "flex items-center font-ubuntu stroke-current  rounded text-sm w-full focus:outline-none hover:bg-caramBar";
  const outlineStyle = "border border-chestNut text-chestNut hover:text-white";
  const normalStyle = "bg-chestNut text-white";
  const disabledStyle =
    "disabled:cursor-not-allowed disabled:select-none disabled:bg-lunarRock disabled:text-rhythmBlues disabled:border-0";

  return (
    <button
      data-testid="button"
      type={type}
      onClick={onClick}
      className={clsx({
        [defaultStyle]: true,
        [outlineStyle]: outline,
        [normalStyle]: !outline,
        [disabledStyle]: disabled,
        [classes]: true,
      })}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  outline: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.string,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
};
Button.defaultProps = {
  outline: false,
  disabled: false,
  classes: "",
};
export default Button;
